import LazyLoad from "react-lazyload";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";

const Partnership = () => {
  const homeMenu = [
    { label: "Vision", link: "/about" },
    {
      label: "Management",
      link: "",
      subMenu: [
        { label: "Director-Principal's Message", link: "/PrincipalMessage" },
        { label: "Leadership Team", link: "/leadershipTeam" },
        { label: "Patron’s Message", link: "/patrons" },
        { label: "Advisory Board", link: "/advisoryBoard" },
      ],
    },

    { label: "International Collaborations", link: "/partnership" },
    // { label: "Awards & Achievements", link: "/awardsAcheivements" },

{
      label: "Awards & Achievements",
      link: "/awardsAcheivements",
      subMenu: [
        { label: "Accolades & Achievements", link: "/awardsAcheivements" },
        { label: "Students Achievements", link: "/studentsAcheivements" },
      ],
    },

    { label: "Faculty", link: "/faculty" },
    { label: "Staff Details", link: "/staffDetails" },
    { label: "School Strength ", link: "/schoolStrength" },
    {
      label: "Gallery",
      link: "/Gallery",
      subMenu: [
        { label: "Photo Gallery", link: "/Gallery" },
        { label: "Video Gallery", link: "/VideoGallery" },
      ],
    },
  ];
  return (
    <>
      <Header />
      <Breadcrumb breadImage="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/banner-partnership.jpg" />
      <Menu MenuItem={homeMenu} />
      <div className="padding-blk inner-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <PageTitle
                pageTitle="International Collaborations"
                breadEnd="Partnerships"
                breadMid="Partnerships"
              />
            </div>
          </div>
          <div className="row partnership">
            <div className="col-md-12">
              <h4 className="color-red mb-4 font-bold">
                International Collaborations
              </h4>

              <div class="accordion" id="accordionExample">
                <div class="accordion-item">
                  <h2 class="accordion-header" id="headingfive">
                    <button
                      class="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapsefive"
                      aria-expanded="true"
                      aria-controls="collapsefive"
                    >
                      Bringing the World into Our Classrooms
                    </button>
                  </h2>
                  <div
                    id="collapsefive"
                    class="accordion-collapse collapse show"
                    aria-labelledby="headingfive"
                    data-bs-parent="#accordionExample"
                  >
                    <div class="accordion-body">
                      <h5>
                        <center>
                          <b>
                            <i>Bringing the World into Our Classrooms</i>
                          </b>
                        </center>
                      </h5>
                      <p>
                        Committed to nurturing globally aware and compassionate
                        citizens, Lotus Valley International School, Gurugram,
                        spares no effort in providing its learners with
                        international exposure from an early age. To this end,
                        it collaborates with partner schools across continents
                        to offer academic and cultural exchange programmes.
                        Given below are the key initiatives stemming from the
                        international collaborations of the school:
                      </p>
                      <div className="row">
                        <div className="col-md-4 col-12">
                          <div class="img-box">
                            <LazyLoad>
                              {" "}
                              <img
                                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/15_1.jpg"
                                alt="Lotus Valley International School, Gurgaon"
                                className="wid-500 img-fluid float-end"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-md-4 col-12">
                          <div class="img-box">
                            <LazyLoad>
                              {" "}
                              <img
                                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/15_2.jpg"
                                alt="Lotus Valley International School, Gurgaon"
                                className="wid-500 img-fluid float-end"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-md-4 col-12">
                          <div class="img-box">
                            <LazyLoad>
                              {" "}
                              <img
                                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/15_3.jpg"
                                alt="Lotus Valley International School, Gurgaon"
                                className="wid-500 img-fluid float-end"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                      </div>
                      <br></br>
                      <h5>
                        <b>
                          <center>
                            Cultural Exchange with IES Sierra de Guadarrama,
                            Madrid{" "}
                          </center>
                        </b>
                      </h5>
                      <p>
                        The school facilitated an Indo-Spain Inter-cultural cum
                        Educational Programme in collaboration with
                        <b>
                          {" "}
                          IES Sierra de Guadarrama, Soto del Real, Madrid from
                          21st to 29th March, 2025.{" "}
                        </b>{" "}
                        As many as 42 learners from Grades VII–XII participated
                        in the programme, accompanied by Director-Principal Ms
                        Anita Malhotra, Academic Supervisor Ms Hina Naqvi,
                        Science Facilitator Ms Namita Chandra, and Spanish
                        Language Mentor Ms Aashima Bhatia.{" "}
                      </p>
                      <p>
                        Exploring the vibrant learning environment of IES Sierra
                        de Guadarrama, learners engaged in interactive sessions
                        that deepened their understanding of Spanish education
                        while enhancing their linguistic skills.The journey
                        extended beyond the school as they explored Madrid’s
                        historical and artistic landmarks, including the
                        bustling Gran Vía, the legendary Don Quijote statue, the
                        iconic Banco de España, and the majestic Alcalá Gate. A
                        visit to the Science Museum further enriched the
                        experience, sparking curiosity and appreciation for
                        innovation and creativity.This exchange was more than
                        just a visit—it was a transformative journey of
                        learning, cultural appreciation, and friendship.{" "}
                      </p>
                      <h5>
                        <b>
                          <center>
                            Educational Exchange with Clara-Schumann Gymnasium,
                            Lahr, Germany{" "}
                          </center>
                        </b>
                      </h5>
                      <p>
                        Under the prestigious PASCH (Partnerschulen im Ausland)
                        programme devised by PAD (Pädagogischer
                        Austauschdienst), Lotus Valley International School has
                        nurtured an enduring partnership with{" "}
                        <b>
                          {" "}
                          Clara-Schumann-Gymnasium, Lahr, Germany since 2016.
                        </b>{" "}
                        For the third time since the inception of this
                        programme, a team of 20 learners from Grades IX-XII
                        participated in a two-week Indo-German Educational and
                        Cultural Exchange Programme from{" "}
                        <b>5th to 18th May, 2025. </b> During their trip,
                        learners stayed with their German host families, gaining
                        first-hand experience of the local culture, traditions,
                        values, and cuisine, while also sharing their own.{" "}
                      </p>
                      <p>
                        At Clara-Schumann-Gymnasium, they attended classes
                        across a range of subjects, experiencing diverse
                        pedagogical styles and learning methods.They had the
                        privilege of meeting Mr. Tilman Peters, the Mayor of
                        Lahr, at the town hall, where they obtained insights
                        into German local governance through an engaging
                        interaction. An academic highlight was a study tour to
                        Herrenknecht, a leading tunnel boring company, where
                        learners explored cutting-edge STEM innovations and
                        sustainable technologies. The much-awaited attraction
                        was the visit to Strasbourg, France, where learners
                        explored the iconic cathedral and local markets and
                        enjoyed a scenic boat ride through the historic La
                        Petite France district, gaining insights into European
                        history and cultural diversity.
                      </p>
                      <div className="row">
                        <div className="col-md-6 col-12">
                          <div class="img-box">
                            <LazyLoad>
                              {" "}
                              <img
                                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/15_4.jpg"
                                alt="Lotus Valley International School, Gurgaon"
                                className="wid-500 img-fluid float-end"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-md-6 col-12">
                          <div class="img-box">
                            <LazyLoad>
                              {" "}
                              <img
                                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/15_5.jpg"
                                alt="Lotus Valley International School, Gurgaon"
                                className="wid-500 img-fluid float-end"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                      </div>
                      <br></br>
                      <h5>
                        <b>
                          <center>
                            International Collaboration with Shibaura Institute
                            of Technology, Japan
                          </center>
                        </b>
                      </h5>
                      <p>
                        The Japanese delegation from{" "}
                        <b>
                          {" "}
                          Shibaura Institute of Technology Junior & Senior High
                          School Japan,
                        </b>{" "}
                        visited India from <b>27th to 29th March, 2025 </b> as
                        part of the exchange programme. Learners of Grades X and
                        XII played perfect hosts and presented a special
                        assembly on Wednesday, 27th March 2024 during which they
                        greeted the Japanese delegates with garlands and tilak.
                        Director-Principal Ms Anita Malhotra’s gracious address
                        made everyone feel at home.
                      </p>
                      <p>
                        This was followed by the morning prayer and a vibrant
                        presentation, showcasing the myriad colours and
                        traditions of India's rich cultural tapestry laying
                        special focus on the UNESCO sites viz Taj Mahal and
                        Chittorgarh Fort, along with eminent Indian institutes
                        such as the IITs and IIMs. A display of the practice of
                        Yoga and how it is akin to the Japanese concept of
                        ikigai, highlighted shared emphasis on finding purpose,
                        fulfillment, and inner peace. Another highlight of the
                        assembly was the captivating presentation by the
                        vivacious Japanese learners, wherein they quizzed the
                        audience on Japanese culture and values.The ceremony
                        came to a close with the reverent instrumental rendition
                        of the national anthems of both, India and Japan,
                        symbolizing unity and mutual respect shared by the two
                        nations.
                      </p>
                      <div className="row">
                        <div className="col-md-4 col-12">
                          <div class="img-box">
                            <LazyLoad>
                              {" "}
                              <img
                                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/15_6.jpg"
                                alt="Lotus Valley International School, Gurgaon"
                                className="wid-500 img-fluid float-end"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-md-4 col-12">
                          <div class="img-box">
                            <LazyLoad>
                              {" "}
                              <img
                                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/15_7.jpg"
                                alt="Lotus Valley International School, Gurgaon"
                                className="wid-500 img-fluid float-end"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-md-4 col-12">
                          <div class="img-box">
                            <LazyLoad>
                              {" "}
                              <img
                                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/15_8.jpg"
                                alt="Lotus Valley International School, Gurgaon"
                                className="wid-500 img-fluid float-end"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                      </div>
                      <br></br>
                      <h5>
                        <b>
                          <center>
                            Student Exchange with Lycee Suger High School in St.
                            Denis, Paris
                          </center>
                        </b>
                      </h5>
                      <p>
                        Lotus Valley International School, Gurugram,
                        successfully organised an Indo-French Immersion
                        Programme from <b> 4th to 15th November, 2024</b> in
                        collaboration with{" "}
                        <b> Lycee Suger High School in St. Denis, Paris. </b>{" "}
                        This remarkable journey took 40 enthusiastic Lotusians
                        from Grades VIII to XI to the heart of France, where
                        they explored Paris, Versailles, and Normandy, fostering
                        cross-cultural connections.
                      </p>
                      <p>
                        The adventure began in Paris, where the city’s
                        enchanting charm embraced the learners. The aromatic
                        boulangeries, the mesmerizing sights of the Eiffel
                        Tower, and the serene beauty of Sacre-Coeur painted an
                        unforgettable canvas. The key highlights included a
                        Bateau Mouche cruise along the Seine; unveiling the
                        historical and architectural marvels of Paris; an
                        insightful exploration of the Palace of Versailles and a
                        reflective visit to the historic shores of Normandy. A
                        visit to the Musée du Louvre added a touch of artistic
                        brilliance to the trip, where learners admired
                        masterpieces like the Mona Lisa, bringing history and
                        creativity to life. The adventure concluded with a
                        magical day at Disneyland Paris, where thrilling rides
                        and the vibrant Disney Parade left everyone spellbound.
                      </p>
                      <div className="row">
                        <div className="col-md-6 col-12">
                          <div class="img-box">
                            <LazyLoad>
                              {" "}
                              <img
                                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/15_9.jpg"
                                alt="Lotus Valley International School, Gurgaon"
                                className="wid-500 img-fluid float-end"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-md-6 col-12">
                          <div class="img-box">
                            <LazyLoad>
                              {" "}
                              <img
                                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/15_10.jpg"
                                alt="Lotus Valley International School, Gurgaon"
                                className="wid-500 img-fluid float-end"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                      </div>
                      <br></br>
                      <h5>
                        <b>
                          <center>
                            Educational Exchange with Hanoi Adelaide School,
                            Vietnam
                          </center>
                        </b>
                      </h5>
                      <p>
                        Lotus Valley International School, Gurugram organised an
                        Educational Exchange Programme in partnership with Hanoi
                        Adelaide School, Vietnam for the learners of Grades
                        VII-XII from 24th to 29th September, 2023.
                        Director-Principal Ms Anita Malhotra accompanied the
                        learners on this wonderful expedition. Mr. Hugo, the
                        Communication Head of Hanoi Adelaide School, warmly
                        welcomed the Director-Principal Ms Anita Malhotra and
                        her team, and thanked her for initiating the exchange
                        programme with their school.
                      </p>
                      <p>
                        The tour included visits to some of Vietnam's most
                        iconic tourist destinations, such as the ancient town of
                        Hoi An, Ngoc Son Temple, Temple of Literature, One
                        Pillar Pagoda, Hoan Kiem Lake, The Old Quarter, an
                        Amusement Park in Sun world Halong Complex, Hanoi Bamboo
                        Silk, Lacquer Shops and more.
                      </p>
                      <p>
                        A visit to a Ha Long Pearl Farm provided insight into
                        the meticulous process of pearl cultivation. The
                        one-night, two-day trip to Halong Bay on Syrena Cruise
                        was truly a delight. Exploring the ancient caves at
                        Halong Bay and The Thien Cung Cave gave learners a
                        glimpse into the geological history of the region and
                        left them in awe of the wonders of nature.{" "}
                      </p>

                      <div className="row">
                        <div className="col-md-4 col-12">
                          <div class="img-box">
                            <LazyLoad>
                              {" "}
                              <img
                                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/15_11.jpg"
                                alt="Lotus Valley International School, Gurgaon"
                                className="wid-500 img-fluid float-end"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-md-4 col-12">
                          <div class="img-box">
                            <LazyLoad>
                              {" "}
                              <img
                                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/15_12.jpg"
                                alt="Lotus Valley International School, Gurgaon"
                                className="wid-500 img-fluid float-end"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-md-4 col-12">
                          <div class="img-box">
                            <LazyLoad>
                              {" "}
                              <img
                                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/15_13.jpg"
                                alt="Lotus Valley International School, Gurgaon"
                                className="wid-500 img-fluid float-end"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="headingfour">
                    <button
                      class="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapsefour"
                      aria-expanded="true"
                      aria-controls="collapsefour"
                    >
                      Globalization is not a monolithic force but an evolving
                      set of consequences.
                    </button>
                  </h2>
                  <div
                    id="collapsefour"
                    class="accordion-collapse collapse"
                    aria-labelledby="headingfour"
                    data-bs-parent="#accordionExample"
                  >
                    <div class="accordion-body">
                      <div class="text-box">
                        <p className="partnershipitalic">
                          {" "}
                          <i>
                            {" "}
                            Globalization is not a monolithic force but an
                            evolving set of consequences. Some good, some
                            thought-provoking and some challenging. It is the
                            new reality.{" "}
                          </i>{" "}
                          <strong>- John B Larsen</strong>
                        </p>

                        <div class="img-box ryt-img">
                          <LazyLoad>
                            {" "}
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/foreign-collaboration.jpg"
                              alt="Brown University || Lotus Valley International School, Gurgaon"
                              className="wid-500 img-fluid float-end"
                            />
                          </LazyLoad>
                        </div>
                        <p>
                          Globalization 1.0 began around 1492, and the world
                          went from size large to size medium. In Globalization
                          2.0, the era that introduced us to multinational
                          companies, it went from size medium to size small. And
                          then around 2000 came Globalization 3.0, in which the
                          world went from being small to tiny with the
                          Globalization seeping into classrooms!
                        </p>
                        <p>
                          Lotus Valley International School not only takes pride
                          in its most modern infrastructure, but also in its
                          invasion into the global community intertwining the
                          S.T.E.A.M education with an international zest. The
                          school has always encouraged its learners to stretch
                          their scholastic and co-scholastic horizons beyond
                          boundaries and probe into the new-fangled
                          all-encompassing world. Ours is a young school with
                          high aspirations and a desire to soar up into the high
                          skies viewing the world as one global village.
                        </p>
                        <p></p>
                        <p className="partnershipitalic">
                          <i>
                            “A community that learns together, excels together.
                            When we learn and work together, we prosper
                            together. We need to form such communities that
                            mutually benefit from each other and what better can
                            it be when these communities being global”.
                          </i>{" "}
                        </p>
                        <p>
                          Our journey to global networking began in 2012 with
                          our tie up <strong>Brown University</strong>, an Ivy
                          League Research University, Rhode Island, United
                          States. Brown University and Lotus Valley alliance has
                          opened new doors for our students and teachers to
                          reach the pinnacle. The experience so far has been
                          quite enriching, both in terms of interaction of prof.
                          Kenneth Wong and his team of teachers and students
                          with our students mainly through Skype sessions. The
                          prospects of our learners would be in best hands with
                          a guarantee of a lucrative future.
                        </p>
                        <p></p>

                        <p>
                          Working for The International Award in 2013 brought us
                          face to face with{" "}
                          <strong>The Ravensbourne School</strong>, Bromley in
                          UK. The association of Lotus Valley International
                          School with The Ravensbourne School, UK enters its
                          third year as we constantly and collaboratively
                          prepare our young learners for further experiences and
                          the world of work. It all began with the visit of the
                          Principal, Mrs. Anita Malhotra followed by
                          Headmistress Mrs. Harvinder Kaur to the UK school
                          while we too hosted Ms. Louise in Oct, 2014, a
                          Geography teacher, Mr. Phil Croft, a History and Law
                          facilitator, in the month of November, 2015 and
                          English facilitators, Mr. David Jordan and Mrs. Andree
                          Jordan, in the month of Dec, 2015.
                        </p>
                        <p>
                          The ISA project also gave our learners an opportunity
                          to interact with{" "}
                          <strong>Watphramahathat School</strong>, Nakhon Si
                          Thammarat province, Thailand. The learners worked on a
                          project called ‘Families’ and exchanged views about
                          the family system in their societies.
                        </p>
                        <p>
                          In today’s era, multilingualism has become more than
                          just ‘important’. Learning Mandarin is more than
                          learning a language, it enables us to explore one of
                          the most ancient culture of the world and is the most
                          widely spoken language in the world. Lotus Valley
                          decided to venture into the field of Chinese Language
                          with the start of the <strong>Mandarin Club</strong>{" "}
                          which prompted us to form the{" "}
                          <strong>‘Lotus Valley Mandarin Club’</strong> in
                          2015-16. The learning of Mandarin has been taking
                          place through Skype sessions with{" "}
                          <strong>The Ravensbourne School</strong>, UK and
                          Suzhou High School, China.
                        </p>
                        <div class="img-box ryt-img">
                          <LazyLoad>
                            {" "}
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/big5.jpg"
                              alt="Germany Student Exchange || Lotus Valley International School, Gurgaon"
                              className="wid-500 img-fluid float-end mx-4 my-4"
                            />
                          </LazyLoad>
                        </div>
                        <p>
                          Discussion over partnership was held in July, 2016,
                          between Mrs. Anita Malhotra, Principal of Lotus Valley
                          International School, Gurgaon &amp; Mr. Joachim
                          Rohrer, Principal,{" "}
                          <strong>
                            Clara Schumann Gymnasium, Lahr, Germany
                          </strong>{" "}
                          to formalize the future prospects in terms of student
                          exchange in the year (2016-18). The Indo-German
                          Exchange Programme brought together learners of both
                          schools for a face to face experiential learning in
                          the year 2016-17 with the visit of the German students
                          to Gurgaon in October, 2016 and educational trip of
                          our learners in May, 2017.
                        </p>

                        <p></p>
                        <p>
                          Lotus Valley is in the process of working-out
                          student-teachers’ exchange programme with Australian
                          schools and universities in collaboration with the
                          Australian High Commission in Delhi. Our Principal,
                          Mrs. Anita Malhotra, visited the highly prestigious
                          International Schools Mission in Australia, in the
                          month of April, 2016 for discussions regarding the
                          same. There have been encouraging response from The
                          University of Technology, Sydney and the Bond
                          University in addition to exposure to working towards
                          India-Australia employability in the years to come.
                          The school hosted Ms Li Richardson from Bachhus Marsh
                          Grammar School, Victoria in January, 2017 which will
                          be reciprocated by the visit of Ms Anjana Menon to
                          Australia in mid-year, 2017.
                        </p>

                        <p>
                          India’s talent has to play a larger role at an
                          International level and Indian Institutes have to
                          prepare to stay at the cutting edge of teaching
                          technology. This can be best done by benchmarking best
                          teaching practices and curriculum details across the
                          globe. Through globalization we aim to re-examine some
                          of our ideas, and look at ideas from other countries,
                          from other cultures and open ourselves to them.
                        </p>

                        <p className="text-center">
                          "The experiences are lovely, enriching and inspiring,{" "}
                          <br />
                          But we have long journey to undertake, <br />
                          And miles to go before we rediscover, <br />
                          And miles to go before outcomes we garner"
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default Partnership;
